import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import HealthSummaryPrint from '../profile/HealthSummaryPrint';
import { connect } from "react-redux";
import MyChartContainer from "../mychart/MyChartContainer";

class HealthSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            onError: false
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.onError = this.onError.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.HealthSummary.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    onError() {
        if (!this.state.onError) {
            this.setState({ onError: true });
        }
    }

    render() {
        const { serverData } = this.props;
        const { onError } = this.state;
        const heading = (
            <>
                <Modal className="info-modal" isOpen={this.state.openModal} toggle={this.toggleModal} centered>
                    <ModalHeader toggle={this.toggleModal} />
                    <ModalBody>
                        <HealthSummaryPrint serverData={serverData} healthSummaryTypes={['Current Health Issues', 'Medications', 'Allergies', 'Immunizations', 'Preventive Care', 'ALL RECORDS']} />
                    </ModalBody>
                </Modal>
                {!onError && <button className="btn btn-icon-only health-summary bswh-mychart-overlay" title="Print" aria-label="Print" onClick={this.toggleModal}><span className="icon-print" /></button>}
            </>
        );

        return <MyChartContainer mode="snapshot" navigation="hide" mychartError={this.onError} containerClass="health-summary-container" heading={heading} />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};

const HealthSummaryWithData = connect(
    mapStateToProps
)(HealthSummary);

export default HealthSummaryWithData;